<template>
<ContentWrapper>
    <div class="content-heading">
      <div>{{data.title}}</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          게시물 관리
        </li>
        <li class="breadcrumb-item active">
          <a :href="data.url">{{data.title}}</a>
        </li>
      </ol>
    </div>
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="작성일" :data="data" @search="search"/>
          <!-- 분류 -->
          <div class="form-group no-margin row" style="width:100%">
            <div class="col-auto">
              <label class="col-form-label">채널</label>
            </div>
            <div class="col-auto">
              <b-input-group class="mt-2 mb-1">
                <div class="form-check mb-2">
                  <input class="form-check-input" :id="`user-type-all`" v-model="data.selectAllUserType"
                    value="" type="checkbox"/>
                  <label class="form-check-label" :for="`user-type-all`">전체</label>
                </div>
                <div v-for="(item, index) in contentsUserTypes.array" :key="index" class="form-check mb-2 ml-3">
                  <input class="form-check-input" :id="`user-type-${index}`" v-model="data.selectedUserTypes" 
                    :value="item.value" type="checkbox"/>
                  <label class="form-check-label" :for="`user-type-${index}`">{{item.text}}</label>
                </div>
              </b-input-group>
            </div>

            <div class="col-auto">
              <label class="col-form-label">학교급</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="schoolGrdCdOption" v-model="data.params.schlGrdCd" @change="schoolGradeChanged();" class="custom-select custom-select-sm"></b-form-select>
            </div>

            <div v-show="type=='sharingContents'" class="col-auto">
              <label class="col-form-label">학년</label>
            </div>
            <div v-show="type=='sharingContents'" class="col-auto">
                <b-form-select :options="schoolLevelOption.values" v-model="data.params.schoolLevel" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>

            <div class="col-auto">
              <label class="col-form-label">과목</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="subjectCdOption.values" v-model="data.params.subjectCd" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>
            
          </div>
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" style="width:100%"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->

    <!-- 목록 -->
    <div class="card card-default">
      <div class="card-header mt-2">
        
        <span class="text-bold h4">목록</span>
        <ShowCounter label="Show" class="ml-1" :data="data" @search="search" />
      </div>
      <div v-if="type=='sharingContents'" class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td width="4%" style="text-align:center">No</td>
              <td width="7%" style="text-align:center" >채널</td>
              <td style="text-align:center" @click="localSort.sort('shareTitle')" >제목<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="7%" style="text-align:center" @click="localSort.sort('name')" >작성자<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="15%" style="text-align:center" @click="localSort.sort('regDt')" >작성일<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="13%" style="text-align:center" >VIEW<br/>(다운/스크랩/좋아요)</td>
              <td width="10%" style="text-align:center" @click="localSort.sort('commentCount')" >댓글관리<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="8">No matching records</td> </tr>
            <template v-for="(item, index) in data.list">
              <tr :key="index">
                <td class="align-middle text-center">{{data.params.limit*(data.params.page-1) + index+1}}</td>
                <td class="align-middle text-center">{{contentsUserTypes.getText(item.typeCd)}}</td>
                <td class="align-middle text-center">
                  {{item.shareTitle}}
                  <br v-show="item.unitResourceList.length > 0"/>
                  <template v-for="(fileItem, fileIndex) in item.unitResourceList">
                    <a :key="'file_a_' + fileIndex" href="javascript:void(0)" @click="showContentsViewer(fileItem)">{{fileItem.name}}</a>
                    <br :key="'file_br_' + fileIndex" v-show="fileIndex < item.unitResourceList.length-1"/>
                  </template>
                </td>
                <td class="align-middle text-center">{{item.name}}</td>
                <td class="align-middle text-center">{{item.regDt}}</td>
                <td class="align-middle text-center">
                  {{item.viewCount}}<br/>({{`${item.fileDownloadCount}/${item.scrapCount}/${item.likeCount}`}})</td>
                <td class="align-middle text-center">
                  <a v-if="item.commentCount > 0" href="javascript:void(0);" @click="goCommentList(item.shareSeq)">{{item.commentCount}}</a>
                  <span v-else>{{item.commentCount}}</span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div v-if="type=='onlineContents'" class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td width="4%" style="text-align:center">No</td>
              <td width="8%" style="text-align:center" >채널</td>
              <td style="text-align:center" @click="localSort.sort('contTitle')" >제목<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="12%" style="text-align:center" @click="localSort.sort('contTypeCd')" >콘텐츠 유형<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="7%" style="text-align:center" @click="localSort.sort('userId')" >작성자<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="15%" style="text-align:center" @click="localSort.sort('regDt')" >작성일<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="13%" style="text-align:center" >복사/스크랩/좋아요</td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="8">No matching records</td> </tr>
            <template v-for="(item, index) in data.list">
              <tr :key="index">
                <td class="align-middle text-center">{{data.params.limit*(data.params.page-1) + index+1}}</td>
                <td class="align-middle text-center">{{contentsUserTypes.getText(item.typeCd)}}</td>
                <td class="align-middle text-center">
                  <a href="javascript:void(0)" @click="showContentsViewer(item)">{{item.contTitle}}</a>
                </td>
                <td class="align-middle text-center">{{onlineContTypeCd.get(item.contTypeCd)}}</td>
                <td class="align-middle text-center">{{item.maskedUserId}}</td>
                <td class="align-middle text-center">{{item.regDt}}</td>
                <td class="align-middle text-center">
                  {{`${item.copyCount}/${item.scrapCount}/${item.likeCount}`}}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->
    
    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>

<script>
import Vue from 'vue';
import store from "@/store/index";
import { reactive, ref, watch, computed, onMounted } from '@vue/composition-api'
import {dataObject, contentsUserTypes, subjectCd1, subjectCd2, subjectCd3, ValueTexts, schoolGrdCdOption, onlineContTypeCd} from "@/utils/Constants";
import * as comApi from "@/api/community/CommunityAPI";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import {__show_ybm_viewer} from "@/utils/common-util";
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {SchDateRange, SchText, ShowCounter, Pagenation, Loading},
    props: {
      type:{
        type:String,
        default:'sharingContents' // 'sharingContents':나눔자료, 'onlineContents' : 온라인컨텐츠
      }
    },
    setup(props, {root}) {
      const isTest = false;
      const modalLoading = ref(false);

      const _dataObject = _.cloneDeep(dataObject);
      _dataObject.selectedUserTypes = contentsUserTypes.array.map((item) => item.value);
      _dataObject.selectAllUserType = computed({
        get() {
          return data.selectedUserTypes.length == contentsUserTypes.array.length;
        },
        set(newValue) {
          if (newValue) {
            data.selectedUserTypes = contentsUserTypes.array.map((item) => item.value);
          } else {
            data.selectedUserTypes = [];
          }
        }
      });
      const data = reactive(_dataObject);
      console.log('data.selectedUserTypes:', data.selectedUserTypes);
      
      const schoolLevelOption = reactive({
        values:[
        {value:'',text:'학교급을 선택해주세요.'},
      ]});

      const subjectCdOption = reactive({
        values:[
        {value:'',text:'학교급을 선택해주세요.'},
      ]});

      const retVals = {
        isTest,
        modalLoading,
        schoolGrdCdOption,
        schoolLevelOption,
        subjectCdOption,
        contentsUserTypes,
        onlineContTypeCd,
        data,
        ...methods(props, data),
        dataAction: new TableActionClass(data),
        localSort:root.$_localSort
      }

      onMounted(async () => {
        retVals.setTitleAndUrl();
        if (store.state.params.name == props.type) {
          const storedData = store.state.params.data;
          retVals.data.params = storedData.params;
          retVals.data.selectedUserTypes = storedData.userTypes;
          store.commit('setParams', {name:'', data:undefined});

          retVals.setSchoolLevelAndSubjectOption();
        } else {
          retVals.reset();
        }
        await retVals.search();
      });
      watch(() => props.type, async (params, oldParams) => {
        console.log(`watch:${oldParams} => ${params}`);
        data.list = [];
        retVals.setTitleAndUrl();
        await retVals.resetSearch();
      });

      return retVals;
    }
}

function methods(props, data) {

  function setTitleAndUrl() {
    if (props.type == 'sharingContents') {
      data.title = '나눔자료 관리';
      data.url = '/community/sharingContentsList';
      data.schOptions = [
        {value:'shareTitle', text:'제목'},
        {value:'name', text:'작성자'},
      ];
    } else {
      data.title = '온라인콘텐츠 관리';
      data.url = '/community/onlineContentsList';
      data.schOptions = [
        {value:'contTitle', text:'제목'},
        {value:'userId', text:'작성자'},
      ];
    }
  }

  function setSchoolLevelAndSubjectOption() {
    const allValue = {value:'', text:'전체'};

    const schoolLevels = [
      {value:'1', text:'1학년'},
      {value:'2', text:'2학년'},
      {value:'3', text:'3학년'},
      {value:'4', text:'4학년'},
      {value:'5', text:'5학년'},
      {value:'6', text:'6학년'},
    ];

    const midHighSchlLevels = schoolLevels.filter((item) => !['4', '5', '6'].includes(item.value));

    switch(this.data.params.schlGrdCd){
      case '301002' : 
        this.schoolLevelOption.values = [allValue, ...schoolLevels];
        this.subjectCdOption.values = [allValue, ...subjectCd1];
        break;
      case '301003' : 
        this.schoolLevelOption.values = [allValue, ...midHighSchlLevels];
        this.subjectCdOption.values = [allValue, ...subjectCd2];
        break;
      case '301004' : 
        this.schoolLevelOption.values = [allValue, ...midHighSchlLevels];
        this.subjectCdOption.values = [allValue, ...subjectCd3];
        break;
      case '':
        this.schoolLevelOption.values =[{value:'',text:'학교급을 선택해주세요.'}];
        this.subjectCdOption.values =[{value:'',text:'학교급을 선택해주세요.'}];
        break;
    }
  }

  async function schoolGradeChanged() {
    this.setSchoolLevelAndSubjectOption();
    this.data.params.schoolLevel = '';
    this.data.params.subjectCd = '';
    this.search(1);
  }

  // 조건 리셋후 검색
  async function resetSearch() {
      await this.reset();
      await this.search();
  }

  function reset() {
    console.log('reset:', props, data);

    data.params.page = 1;
    data.params.schlGrdCd = '';
    data.params.schoolLevel = '';
    data.params.subjectCd = '';
    data.params.schType = '';
    data.params.schText = '';

    this.setSchoolLevelAndSubjectOption();

  }

  // 목록
  async function search(page) {
    console.log('search:', data);

    if (!isNaN(page)) {
      data.params.page = page;
    }

    // typeCd 설정
    if (data.selectedUserTypes.length == 1) {
      data.params.typeCd = data.selectedUserTypes[0];
    } else {
      // length == 2 인 경우에도 '' 로 해서 전체 검색으로 전달한다.
      data.params.typeCd = '';
    }

    // data.params 추가 수정
    data.params.schoolCategoryCd = data.params.schlGrdCd;
    if (props.type == 'sharingContents') {
      data.params.gradeJson = data.params.schoolLevel;
    } else {
      data.params.gradeJson = undefined;
    }
    
    let result = undefined;
    if (props.type == 'sharingContents') {
      result = await comApi.getSharingContentsList(data.params, this.isTest);
    } else {
      result = await comApi.getOnlineContentsList(data.params, this.isTest);
    }
    data.list = result.data;
    data.count = result.count;
    this.localSort.set(data.list);
  }

  // 댓글 목록
  function goCommentList(shareSeq) {
    if (props.type == 'sharingContents') {
      this.$store.commit('setParams', {name:props.type, data:{userTypes:data.selectedUserTypes, params:data.params}});
      const name = 'sharingContentsComment';
      this.$router.push({name:name, params:{type:name, objectSeq:shareSeq, 
        schStartDt:data.params.schStartDt, schEndDt:data.params.schEndDt}});
    } else { // 온라인콘텐츠는 댓글이 없다.

    }
  }

  // 통합뷰어 열기
  function showContentsViewer(fileItem) {

    let v_params = null;

    if (props.type == 'sharingContents') {
      let rsrcTypeCd = fileItem.rsrcTypeCd;
      if (!rsrcTypeCd) {
        rsrcTypeCd = '352005';
      }

      v_params = {
        cont_item:{
          rsrc_type_cd:rsrcTypeCd,
          up_file_seq:fileItem.upFileSeq,
          rsrc_ext:fileItem.ext,
          file_url:fileItem.saveLocation,
          play_start_time:0,
          play_end_time:0
        },
        unit_seq:"",
        cls_seq:-1,
        vg_mode:""
      }

      if (fileItem.parentSeq > 0) {
        v_params.cont_item.parent_seq = fileItem.parentSeq;
      }
    } else { // onlineContents
      const item = fileItem;

      v_params = {
        cont_item:{
          rsrc_type_cd:'352004',
          resource_seq:item.contSeq,
          cont_type:item.contTypeCd,
        },
        unit_seq:item.unitSeq,
        cls_seq:-1,
        vg_mode:""
      }
    }
    
    console.log('v_params:', JSON.stringify(v_params));
    __show_ybm_viewer('ybm.es', 'Ybmsisa00!', v_params, process.env.VUE_APP_LMS_USER_HOST);
  }

  return {
    setSchoolLevelAndSubjectOption,
    schoolGradeChanged,
    setTitleAndUrl,
    resetSearch,
    reset,
    search,
    goCommentList,
    showContentsViewer
  }
}
</script>